// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export const lazyLoadKeyframes = () => {
    return css`
        @keyframes lazyLoad {
            100% {
                transform: translateX(100%);
            }
        }

        @keyframes lazyLoadFadeIn {
            0% {
                opacity: 0;
            }
            100% {
                opacity: 1;
            }
        }
    `;
};

export const lazyImageStyles = () => {
    return css`
        ${({ loaded }: any) => (loaded ? null : lazyLoadStyles())}
    `;
};

export const lazyLoadStyles = () => {
    return css`
        background: ${getColor("common.accent")};
        position: relative;
        overflow: hidden;
        animation: lazyLoadFadeIn 250ms ease;

        &::before {
            content: "";
            position: absolute;
            inset: 0;
            background: linear-gradient(-90deg, transparent 25%, ${getColor("common.background")} 50%, transparent 75%);
            transform: translateX(-100%);
            animation: lazyLoad 2s ease infinite;
        }
    `;
};
